<template>
  <div>
    <section :style="{ backgroundImage: 'url(' + require('@/assets/background_azul.png') + ')' }">
      <div class="container">
        <div class="row pt-4 pb-4">
          <div class="col-md-12">
            <img :src="require('@/assets/banner1.png')" class="img-fluid" />
          </div>
        </div>
      </div>
    </section>
    <section style="background-color: #e6e6e6;">
      <div class="container">
        <div class="row pt-5 pb-5">
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              style="background-color: #0033a0 !important; color: #fff; font-weight: bold; border: 0;"
              @click="$router.push({name: 'infoes'})"
            >ESPAÑOL</button>
          </div>
          <div class="col-md-6">
            <button
              type="button"
              class="btn btn-primary btn-lg btn-block"
              style="background-color: #0033a0 !important; color: #fff; font-weight: bold; border: 0;"
              @click="$router.push({name: 'infopt'})"
            >PORTUGUÊS</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  name: "home",
  data() {
    return {};
  }
};
</script>
<style scoped>
p,
label {
  color: #fff;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
}

.text-danger {
  text-shadow: 1px 1px #000;
}

.barco {
  border: 20px solid #fff;
  -webkit-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 1px 1px 12px 0px rgba(0, 0, 0, 0.75);
}


</style>
